<script lang="ts">
import { NoticeType } from '@/components/molecules/notices/notice-type.definition';
import { ITranslationData } from '../../../../../../modules/translation/translation-data.definition';
import {Component, Vue, Prop} from "vue-facing-decorator"

@Component({
    name: 'BlockNotice'
})
export default class BlockNotice extends Vue {
    @Prop({ default: () => null })
    public readonly content!: ITranslationData | string | null;

    @Prop({ default: () => null })
    public readonly title!: ITranslationData | string | null;

    @Prop({ default: () => NoticeType.Info })
    public readonly type!: NoticeType;

    public readonly NoticeType: typeof NoticeType = NoticeType;

    get isContentTranslation(): boolean {
        return this.content !== null && typeof this.content !== 'string';
    }

    get isTitleTranslation(): boolean {
        return this.title !== null && typeof this.title !== 'string';
    }
}
</script>

<template>
    <div class="m-blockNotice" v-bind:class="{
        '-informational': type === NoticeType.Info,
        '-error': type === NoticeType.Error,
        '-success': type === NoticeType.Success,
        '-warning': type === NoticeType.Warning,
    }">
        <div class="m-blockNotice__content">
            <h2 v-if="title !== null && isTitleTranslation" v-translate="title"></h2>
            <h2 v-if="title !== null && !isTitleTranslation" v-html="title"></h2>

            <p v-if="content !== null && isContentTranslation" v-translate="content"></p>
            <p v-if="content !== null && !isContentTranslation" v-html="content"></p>
        </div>
    </div>
</template>
